import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=a18ef6c8&scoped=true&"
import script from "./pending.vue?vue&type=script&lang=js&"
export * from "./pending.vue?vue&type=script&lang=js&"
import style0 from "./pending.vue?vue&type=style&index=0&id=a18ef6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18ef6c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a18ef6c8')) {
      api.createRecord('a18ef6c8', component.options)
    } else {
      api.reload('a18ef6c8', component.options)
    }
    module.hot.accept("./pending.vue?vue&type=template&id=a18ef6c8&scoped=true&", function () {
      api.rerender('a18ef6c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/pending.vue"
export default component.exports